import { logger } from '../utility/logger'

export default defineNuxtPlugin(() => {
  const _router = useRouter()
  const hydrationStore = useHydrationStore()

  let isHydrating = false

  // Helper function to handle hydration
  const _handleHydration = async () => {
    if (!isHydrating && !hydrationStore.hasNavigated) {
      logger('forcing hydration')
      hydrationStore.hasNavigated = true
      if (hydrationStore.hydrateFunctions.length > 0) {
        isHydrating = true
        await new Promise<void>((resolve) => {
          hydrationStore.setNavigationResolver(resolve)
          hydrationStore.resolveAllHydrations()
        })
        isHydrating = false
      }
    }
  }

  // Keep the beforeEach as a fallback
  // router.beforeEach(async (to, from) => {
  //   if (to.fullPath !== from.fullPath) {
  //     await handleHydration()
  //   }
  // })
})
